import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { EmergencyAnswerGetter } from '@/store/emergencyAnswer/emergencyAnswer.module';
import { EmergencyAnswer, EmergencyAnswerAttachment } from '@/store/emergencyAnswer/emergencyAnswer.model';
import BaseOffcanvasComponent from '@/components/baseOffcanvas/BaseOffcanvas.vue';

export default defineComponent({
  name: 'EmergencyAnswerAttachmentOffcanvasComponent',
  components: {
    BaseOffcanvasComponent
  },
  props: {
    emergencyAnswerId: {
      type: Number,
    },
  },
  setup: (props) => {
    const store = useStore();
    const answer = computed<EmergencyAnswer | undefined>(() => store.getters[EmergencyAnswerGetter.BY_ID](props.emergencyAnswerId));
    const attachments = computed<EmergencyAnswerAttachment[]>(() => (answer.value) ? answer.value?.emergencyAnswerAttachments.filter(m => m.attachmentType.id === 1) : []);
    const images = computed<EmergencyAnswerAttachment[]>(() => (answer.value) ? answer.value?.emergencyAnswerAttachments.filter(m => m.attachmentType.id === 2) : []);
    const attachmentOffcanvas = ref<InstanceType<typeof BaseOffcanvasComponent>>();

    // show modal
    const show = () => {
      attachmentOffcanvas.value?.show();
    };

    // hide modal
    const hide = () => {
      attachmentOffcanvas.value?.hide();
    };

    const attachmentClick = (url: string) => {
      window.open(url, '_blank');
    };

    return {
      attachments,
      images,
      attachmentOffcanvas,
      show,
      hide,
      attachmentClick,
    };
  }
});
